import { CustomPanel } from "@finanedi.es/storybook"
import {
  faAngleDown,
  faAngleRight,
  faTimes,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TFunction } from "i18next"
import { useState } from "react"
import { UseFormSetValue } from "react-hook-form"
import {
  FieldTemplateGeneric,
  renderFieldTemplateGeneric,
} from "../../../PlantillasBloquesTabla"

const OperadoresTemplate = ({
  t,
  text,
  values,
  setValue,
  operadorIndex,
  handleDelete,
}: {
  t: TFunction
  text: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: UseFormSetValue<any>
  operadorIndex: number
  handleDelete: () => void
}) => {
  const [categoryExpanded, setCategoryExpanded] = useState(true)
  const fieldsOperadores: FieldTemplateGeneric[] = [
    {
      id: "row1",
      inputsOne: [
        {
          label: t("taxSummary.declaracion.codigoPais"),
          code: `operadores.${operadorIndex}.codigoPais`,
          value: values?.operadores?.[operadorIndex]?.codigoPais,
          inputType: "text",
        },
        {
          label: t("taxSummary.declaracion.nif"),
          code: `operadores.${operadorIndex}.nif`,
          value: values?.operadores?.[operadorIndex]?.nif,
          inputType: "text",
        },
        {
          label: t("taxSummary.declaracion.name"),
          code: `operadores.${operadorIndex}.razonSocial`,
          value: values?.operadores?.[operadorIndex]?.razonSocial,
          inputType: "text",
          colSpan: "tw-col-span-2",
        },
      ],
    },
    {
      id: "row2",
      inputsOne: [
        {
          label: t("taxSummary.declaracion.key"),
          code: `operadores.${operadorIndex}.clave`,
          value: values?.operadores?.[operadorIndex]?.clave,
          inputType: "text",
        },
        {
          label: t("taxSummary.declaracion.liquidacionModelo.box10titleOne"),
          code: `operadores.${operadorIndex}.baseImponible`,
          value: values?.operadores?.[operadorIndex]?.baseImponible,
          inputType: "currency",
        },
      ],
    },
  ]

  return (
    <CustomPanel
      title={text}
      expandIcon={null}
      collapseIcon={null}
      className='tw-cursor-pointer tw-font-medium !tw-shadow-none tw-border [&>div:nth-child(2)]:!tw-max-h-[3000px]'
      collapsed={categoryExpanded}
      onToggle={(e) => setCategoryExpanded(e.value)}
      headerTemplate={() => (
        <div
          className='tw-flex tw-justify-between tw-px-4 tw-py-3'
          onClick={() => setCategoryExpanded((prevState) => !prevState)}
        >
          <p>{text}</p>
          <div>
            <button
              type='button'
              onClick={(e) => {
                e.stopPropagation()
                handleDelete()
              }}
              className='hover:tw-bg-gray-100 tw-w-6 tw-rounded tw-transition-colors'
            >
              <FontAwesomeIcon
                icon={faTimes}
                className='tw-text-red-500'
              />
            </button>
            <button
              type='button'
              onClick={() => setCategoryExpanded((prevState) => !prevState)}
              className='tw-w-4 tw-ml-4'
            >
              <FontAwesomeIcon
                icon={categoryExpanded ? faAngleDown : faAngleRight}
              />
            </button>
          </div>
        </div>
      )}
    >
      <div className='tw-p-4'>
        {fieldsOperadores.map((row) => (
          <div
            key={row.id}
            className='tw-w-full tw-h-fit tw-grid tw-grid-cols-4 tw-py-3 tw-gap-7 tw-border-b tw-border-neutral-25'
          >
            {renderFieldTemplateGeneric({
              fields: row.inputsOne,
              setValue,
              t,
            })}
          </div>
        ))}
      </div>
    </CustomPanel>
  )
}

export default OperadoresTemplate
